/**
 * TASK-109 (AR-08) — react-query mutation for merging a source record into a
 * target. On success invalidates both the source and target record caches plus
 * the record list, so the merged source disappears and the target refreshes.
 */
import { useMutation, useQueryClient } from 'react-query';
import { useOkapiKy } from '@folio/stripes/core';
import { mergeRecord } from '../api/recordService';
export var useMergeRecord = function (sourceId, targetId, options) {
    if (options === void 0) { options = {}; }
    var ky = useOkapiKy();
    var queryClient = useQueryClient();
    return useMutation(function (body) { return mergeRecord(ky, sourceId, body); }, {
        onSuccess: function (result) {
            var _a;
            queryClient.invalidateQueries(['record', sourceId]);
            if (targetId) {
                queryClient.invalidateQueries(['record', targetId]);
            }
            queryClient.invalidateQueries(['records']);
            (_a = options.onSuccess) === null || _a === void 0 ? void 0 : _a.call(options, result);
        },
        onError: function (error) {
            var _a;
            (_a = options.onError) === null || _a === void 0 ? void 0 : _a.call(options, error);
        },
    });
};
export default useMergeRecord;
